import React from 'react';
import { Card } from "react-bootstrap";
import '../pages/App.css';

function CustomCard({ title, backgroundColor, onClick }) {
  return (
    <Card 
      className="custom-card" 
      style={{ 
        backgroundColor: backgroundColor,
        cursor: 'pointer',
        minHeight: '140px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={onClick}
    >
      <div className="card-content">
        <Card.Body style={{ textAlign: 'center' }}>
          <Card.Title style={{ fontSize: '1.3em', fontWeight: '700', margin: 0 }}>
            {title}
          </Card.Title>
        </Card.Body>
      </div>
    </Card>
  );
}

export default CustomCard;
